import type { Step } from "react-joyride";

export const leaveHistoryTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າປະຫວັດການລາ / ສະຫຼຸບ. ເບິ່ງລາຍການຄຳຂໍລາທີ່ສົ່ງແລ້ວ ຕາມປີ ເດືອນ ສະຖານະ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-history-toolbar"]',
    content: "ຫົວຂໍ້ຫນ້າ. ກົດປຸ່ມວົງມົນເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-history-filter"]',
    content: "ກັ່ນຕອງຕາມປີ, ເດືອນ, ສະຖານະ ແລະ ຄົ້ນຫາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-history-table"]',
    content: "ຕາຕະລາງປະຫວັດຄຳຂໍລາ. ກົດເບິ່ງລາຍລະອຽດ.",
    placement: "top",
  },
];
